import { GoogleMap, useLoadScript, DirectionsRenderer } from '@react-google-maps/api';
import { useState } from 'react';
import axios from "axios";
import { useEffect } from 'react';
import { authData } from '../../components/getAuth';
import Select from "react-select";
import { AsyncPaginate } from 'react-select-async-paginate';

const containerStyle = {
    width: '100%',
    height: '600px'
};

const BookingMap = () => {
    const { isLoaded } = useLoadScript({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
        libraries: ["places"]
    });

    const auth = authData();
    const API_TOKEN = auth?.api_token;

    const center = { lat: 51.509865, lng: -0.118092 };
    const [optimized, setOptimized] = useState(null);
    const [allDriverList, setAllDriverList] = useState([]);
    const [bookingList, setBookingList] = useState([]);
    const [driverList, setDriverList] = useState([]);

    const handleOptimize = async () => {
        try {
            const res = await axios.post("http://localhost:8000/api/v1/optimize-route", { drivers: driverList, pickups: bookingList });
            //const res = await axios.post("http://localhost:8000/api/v1/optimize-route", { locations: bookingList });
            setOptimized(res.data);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + 'v1/p-driver-dd-list', {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            }
        }).then(response => {
            if (response.data.status === 'SUCCESS') {
                setAllDriverList(response.data.data);
            }
        });
    }, [API_TOKEN]);



    /*useEffect(() => {
        if (optimized && optimized?.route) {
            let routePointTemp = optimized?.route?.map(r => {
                if (r.name === driverDetails?.address) {
                    return { lat: parseFloat(driverDetails.lat), lng: parseFloat(driverDetails.lng), name: "Driver Location: " + driverDetails?.address };
                }
                const loc = Object.values(bookingList).find((l) => l.name === r.name);
                return loc ? { lat: parseFloat(loc.lat), lng: parseFloat(loc.lng), name: loc.name } : null;
            });

            setRoutePoints(routePointTemp);
        } else {
            setRoutePoints([]);
        }
    }, [optimized]);*/

    const [directions, setDirections] = useState([]);

    useEffect(() => {
        if (isLoaded && optimized && optimized?.data && optimized?.data?.length > 0) {
            let driverRoutes = optimized?.data;

            const service = new window.google.maps.DirectionsService();

            driverRoutes.forEach((route, idx) => {

                let waypoints = route.optimized_route.slice(1, -1).map((stop) => {
                    let nameArr = stop?.name?.split('-');

                    if (nameArr?.length === 2) {
                        if (nameArr[0] === 'Pickup') {
                            let bId = nameArr[1];

                            const loc = bookingList.find((l) => l.value === parseInt(bId));

                            if (loc) {
                                return {
                                    location: new window.google.maps.LatLng(parseFloat(loc.lat), parseFloat(loc.lng)),
                                    stopover: true,
                                }
                            }
                        }
                    }
                    return null;
                });

                waypoints = waypoints?.filter(i => i !== null);

                let optionsNew = { waypoints: waypoints, travelMode: window.google.maps.TravelMode.DRIVING };

                let nameArr1 = route.optimized_route[0]?.name?.split('-');
                let nameArr2 = route.optimized_route[route.optimized_route.length - 1]?.name?.split('-');

                if (nameArr1?.length === 2) {
                    if (nameArr1[0] === 'Pickup') {
                        let bId = nameArr1[1];

                        const loc = bookingList.find((l) => l.value === parseInt(bId));

                        if (loc) {
                            optionsNew = { ...optionsNew, origin: { lat: parseFloat(loc.lat), lng: parseFloat(loc.lng), name: loc.name } };
                        }
                    }

                    if (nameArr1[0] === 'Driver') {
                        let bId = nameArr1[1];

                        const loc = driverList.find((l) => l.value === parseInt(bId));

                        if (loc) {
                            optionsNew = { ...optionsNew, origin: { lat: parseFloat(loc.lat), lng: parseFloat(loc.lng) } };
                        }
                    }
                }

                if (nameArr2?.length === 2) {
                    if (nameArr2[0] === 'Pickup') {
                        let bId = nameArr2[1];

                        const loc = bookingList.find((l) => l.value === parseInt(bId));

                        if (loc) {
                            optionsNew = { ...optionsNew, destination: { lat: parseFloat(loc.lat), lng: parseFloat(loc.lng) } };
                        }
                    }
                }

                service.route(optionsNew,
                    (result, status) => {
                        if (status === "OK") {
                            setDirections((prev) => [...prev, { idx, result }]);
                        }
                    }
                );
            });
        }
    }, [optimized, isLoaded, bookingList, driverList]);

    const loadOptions = async (search, loadedOptions, { page }) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}v1/assign-bookings?search=${search}&page=${page - 1}&limit=10`
            );
            const data = await response.json();

            // Convert API data into react-select format
            const options = data.data.map((item) => {
                return { value: item?.id, label: item?.reference_id + '(' + item?.post_code + ')', name: item?.reference_id + '(' + item?.post_code + ')', lat: item?.pickup_details?.latitude, lng: item?.pickup_details?.longitude };
            });

            if (options?.length > 0) {
                return {
                    options,
                    hasMore: true,
                    additional: {
                        page: page + 1,
                    }
                }
            } else {
                return {
                    options: [],
                    hasMore: false,
                }
            }
        } catch (error) {
            console.error("Error fetching options:", error);
            return {
                options: [],
                hasMore: false,
            };
        }
    }



    /*useEffect(() => {
        if (!isLoaded) return;
        const directionsService = new window.google.maps.DirectionsService();

        if (routePoints?.length > 1) {
            let options = { travelMode: window.google.maps.TravelMode.DRIVING };
            options = { ...options, origin: routePoints[0], destination: routePoints[routePoints.length - 1] };

            if (routePoints?.length > 2) {
                let wayPointsLoc = routePoints.slice(1, -1)?.map(i => {
                    return { location: i, stopover: true };
                });
                options = { ...options, waypoints: wayPointsLoc };
            }

            directionsService.route(options,
                (result, status) => {
                    if (status === "OK") {
                        setDirections(result);
                    }
                }
            );
        }


    }, [isLoaded, routePoints]);*/


    const colors = ["#FF0000", "#007BFF", "#00AA00", "#FF9900", "#9900FF"];

    return <>
        <div style={{ padding: 20 }}>
            <Select
                options={allDriverList}
                value={driverList}
                onChange={(e) => {
                    setDriverList(e);
                }}
                isMulti
            />
            <AsyncPaginate
                loadOptions={loadOptions}
                value={bookingList}
                onChange={(e) => {
                    setBookingList(e);
                }}
                additional={{ page: 1 }}
                isClearable
                defaultOptions
                debounceTimeout={400}
                isMulti
            />
            <button onClick={handleOptimize}>Optimize Route</button>
        </div>
        {isLoaded && (<GoogleMap mapContainerStyle={containerStyle} center={center} zoom={13}>
            {/*directions && <DirectionsRenderer
                directions={directions}
                options={{
                    suppressMarkers: true, // disables default Google markers
                }}
            />}
            {/* Custom Markers *//*}
            {routePoints.map((pos, idx) => (
                <MarkerF
                    key={idx}
                    position={pos}
                    label={`${idx === 0 ? 'D' : idx}`}
                    /*icon={{
                        url: idx === 0 ? "http://maps.google.com/mapfiles/kml/paddle/flag.png" : idx === routePoints2.length - 1 ? "http://maps.google.com/mapfiles/kml/pal2/icon10.png" : "http://maps.google.com/mapfiles/kml/paddle/star.png",
                        scaledSize: new window.google.maps.Size(40, 40),
                    }}*//*
                    onMouseOver={() => setHoveredMarker(idx)}
                    onMouseOut={() => setHoveredMarker(idx)}
                >
                    {hoveredMarker === idx && (
                        <InfoWindow
                            position={pos}
                        >
                            <div style={{ fontWeight: 'bold' }}>{pos?.name}</div>
                        </InfoWindow>
                    )}
                </MarkerF>
            ))*/}

            {directions.map((d, i) => (
                <DirectionsRenderer
                    key={i}
                    directions={d.result}
                    options={{
                        suppressMarkers: false,
                        polylineOptions: {
                            strokeColor: colors[i % colors.length],
                            strokeWeight: 5,
                            strokeOpacity: 0.8,
                        },
                    }}
                />
            ))}
        </GoogleMap>)}



    </>
}

export default BookingMap;